import { makeStyles } from "@fluentui/react-components";
import { REFINED } from "./risikoanalyseStep/tokens";

/**
 * Das Eingabefeld, in dem ein gefundener Wert direkt in seiner Zeile
 * bearbeitet wird — „Daten aus dem Impressum befüllen" und der Scan-Dialog
 * (T-84) teilen sich diese Optik: schmale Kante, im Fokus Aubergine,
 * gesperrt auf Feldgrund.
 */
export const useInlineWertEingabeStyles = makeStyles({
  eingabe: {
    width: "100%",
    boxSizing: "border-box",
    padding: "6px 8px",
    marginTop: "2px",
    borderRadius: "6px",
    border: `1px solid ${REFINED.line}`,
    fontFamily: "inherit",
    fontSize: "0.88rem",
    color: REFINED.ink,
    backgroundColor: REFINED.white,
    // Griffel verbietet die Longhand `borderColor` neben der Shorthand
    // `border` — im Fokus wird deshalb die ganze Kante neu gesetzt.
    ":focus": { border: `1px solid ${REFINED.aub}`, outlineStyle: "none" },
    ":disabled": { backgroundColor: REFINED.fieldBg, color: REFINED.ink3 },
  },
  /** Ungültige Eingabe — rote Kante, auch im Fokus. */
  ungueltig: {
    border: `1px solid ${REFINED.err}`,
    ":focus": { border: `1px solid ${REFINED.err}` },
  },
});
